import React from 'react';
import '../Estilos/CardDashboard.css';
import '../Estilos/Tooltip.css';
import { checkColor, checkStatus } from '../Funções/CardStatus';
import TopicoTexto from '../Componentes/TopicoTexto';

export default function CardDashboardView(props) {
  return (
    <div
      style={{
        maxWidth: props.maxW !== undefined ? props.maxW : 540,
        maxHeight: props.maxH !== undefined ? props.maxH : 505,
        width: props.width !== undefined ? props.width : '28vw',
        height: props.height !== undefined ? props.height : 540,
        marginBottom: '10%',
      }}
    >
      <div className="NameView">
        <p style={{ color: '#005288', fontSize: '16px' }}>
          <strong>{props.nome}</strong>
        </p>
      </div>
      <div
        style={{
          maxWidth: props.maxW !== undefined ? props.maxW : 540,
          maxHeight: props.maxH !== undefined ? props.maxH : 505,
          width: props.width !== undefined ? props.width : '28vw',
          backgroundColor: 'white',
          height: props.height !== undefined ? props.height : 540,
          marginRight: props.right !== undefined ? props.right : 0,
          marginTop: props.top !== undefined ? props.top : 0,
          borderRadius: 4,
          boxShadow: '0px 3px 6px #00000029',
          marginLeft: 8,
        }}
      >
        <div className="CardView">
          <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '25px', gap: '10px' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '25px',
                gap: '10px',
              }}
            >
              <h4 id="FonteCard" style={{ textAlign: 'center', width: '100%', marginTop: 40 }}>
                TEMPERATURA
              </h4>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: 0,
                  padding: 0,
                  justifyContent: 'center',
                  flexDirection: 'column',
                  height: 120,
                  width: 120,
                  borderRadius: 60,
                  border: `3px solid ${checkColor(props.ok)}`,
                }}
              >
                {props.temperature ? (
                  <h2 className={`Valor ${checkStatus(props.ok)}`}>{props.temperature}°C</h2>
                ) : (
                  <p style={{ color: '#D7998E' }}>
                    <strong>Sem leitura</strong>
                  </p>
                )}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '25px',
                gap: '10px',
              }}
            >
              <h4 id="FonteCard" style={{ marginTop: 40, textAlign: 'center', width: '100%' }}>
                UMIDADE
              </h4>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: 0,
                  padding: 0,
                  justifyContent: 'center',
                  flexDirection: 'column',
                  height: 120,
                  width: 120,
                  borderRadius: 60,
                  border: `3px solid ${checkColor(props.ok)}`,
                }}
              >
                {props.humidity ? (
                  <h2 className={`Valor ${checkStatus(props.ok)}`}>{props.humidity}%</h2>
                ) : (
                  <p style={{ color: '#D7998E' }}>
                    <strong>Sem leitura</strong>
                  </p>
                )}
              </div>
              <h6 id="FonteID" style={{ textAlign: 'center', width: '100%', marginLeft: '-60%' }}>
                {props.data === 'NaN/NaN/NaN NaN:NaN' ? '' : props.data}
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
